import React from 'react';
import { names } from './constants';
import { IconProps } from './types';

import { Container } from './styles';

export const Icon: React.FC<IconProps> = ({
  name,
  size = 'sm',
  color = 'gray5',
  background = 'transparent',
  className = '',
}) => {
  const SelectedIcon = names[name];
  return (
    <Container
      size={size}
      className={`icon ${className}`}
      color={color}
      background={background}
      data-testid="icon"
    >
      <SelectedIcon />
    </Container>
  );
};
